import React from 'react';
import type { IssueSummary, IssueCategorySetting } from '@chatsdet/types/issues';
import { EditableBadge, type EditableBadgeOption } from '@chatsdet/ui';
import { useUpdateIssueCategoryMutation } from '../../../hooks/useIssuesV2';

interface CategoryEditableBadgeProps {
  issue: IssueSummary;
  categories: IssueCategorySetting[];
  onSuccess?: () => void;
}

export function CategoryEditableBadge({ issue, categories, onSuccess }: CategoryEditableBadgeProps) {
  const mutation = useUpdateIssueCategoryMutation(issue.id);

  const options: EditableBadgeOption<string>[] = categories
    .filter((c) => c.isActive)
    .map((c) => ({
      id: c.id,
      label: c.label,
    }));

  const handleChange = (categoryId: string) => {
    mutation.mutate(categoryId, { onSuccess });
  };

  return (
    <EditableBadge
      value={issue.category.id}
      options={options}
      onChange={handleChange}
      variant="secondary"
      size="sm"
      isLoading={mutation.isPending}
      aria-label={`Change category for issue: ${issue.title}`}
    />
  );
}
